import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyBootModule } from 'owa-bundling-light';

const lazyModule: LazyBootModule<typeof lazyIndex> = new LazyBootModule(
    () => import(/* webpackChunkName: "OwsGateway" */ './lazyIndex'),
    { name: 'OwsGateway' }
);

type LazyType = typeof import('./lazyIndex');

// OW 55102. We have to cast this functions because LazyAction has a bug where it doesn't assign the
// correct types with function that return any or Promise<any>
const makePostRequest = new LazyAction(lazyModule, m => m.makePostRequest)
    .importAndExecute as LazyType['makePostRequest'];
const makePatchRequest = new LazyAction(lazyModule, m => m.makePatchRequest)
    .importAndExecute as LazyType['makePatchRequest'];
const makePutRequest = new LazyAction(lazyModule, m => m.makePutRequest)
    .importAndExecute as LazyType['makePutRequest'];
const makeGetRequest = new LazyAction(lazyModule, m => m.makeGetRequest)
    .importAndExecute as LazyType['makeGetRequest'];
const makeDeleteRequest = new LazyAction(lazyModule, m => m.makeDeleteRequest)
    .importAndExecute as LazyType['makeDeleteRequest'];
const makeGraphRequest = new LazyAction(lazyModule, m => m.makeGraphRequest)
    .importAndExecute as LazyType['makeGraphRequest'];
const sendOwsPrimeRequest = new LazyAction(lazyModule, m => m.sendOwsPrimeRequest)
    .importAndExecute as LazyType['sendOwsPrimeRequest'];
const makeNetworkRequest = new LazyAction(lazyModule, m => m.makeNetworkRequest)
    .importAndExecute as LazyType['makeNetworkRequest'];

export {
    makePostRequest,
    makePatchRequest,
    makePutRequest,
    makeGetRequest,
    makeDeleteRequest,
    makeGraphRequest,
    makeNetworkRequest,
    sendOwsPrimeRequest,
};
